import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import BatchTable from "./Component/BatchTable"


const Batch =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <BatchTable />
        </div>
        <Footer />
        </>
    )
}

export default Batch